import { BaseError } from './BaseError.js';
import { CLIENT_ERROR_MESSAGES, type ClientErrorCode } from './constants.js';
import { parseITSError } from './parseITSError.js';

/**
 * Custom Error class to be used within cancelation flow (see createCancel).
 * Every intentional exception within the cancelation flow should use this Error class with a significant error code.
 */
export class CancelWagerError extends BaseError<ClientErrorCode> {
  constructor({
    clientCode,
    code,
    extraData,
    message: errorMessage,
  }: {
    clientCode: ClientErrorCode;
    code?: string;
    extraData?: object;
    message?: string;
  }) {
    let clientErrorCode = clientCode;
    const [parsedClientErrorCode] = parseITSError(code);

    if (parsedClientErrorCode) {
      clientErrorCode = parsedClientErrorCode;
    }
    const paymentMessage = CLIENT_ERROR_MESSAGES[clientErrorCode];

    const message = errorMessage ?? paymentMessage;
    super({ clientCode: clientErrorCode, code, extraData, message });
    this.name = 'CancelWagerError';
  }
}
